import type { ProcessingOptionsInterface } from './interfaces'

export enum RESIZING_TYPE {
  FIT = 'fit',
  FILL = 'fill',
  FILL_DOWN = 'fill-down',
  FORCE = 'force',
  AUTO = 'auto',
}

export type sizeOptionsType = {
  width?: number
  height?: number
  enlarge?: boolean
  extend?: boolean
}

export type resizeOptionsType = sizeOptionsType & {
  rsType?: RESIZING_TYPE
}

export type processingOptions = { [key: string]: ProcessingOptionsInterface }
